export default __webpack_public_path__ + "static/media/bg-hero.2195c881.png";